<div *ngIf="hasImage; else iconBadge" class="sdx--badge badge--avatar badge--notification">
  <div class="avatar">
    <img [src]="image" />
  </div>
  <ng-container [ngTemplateOutlet]="badgeContent"></ng-container>
</div>
<ng-template #iconBadge>
  <div class="sdx--badge badge--notification badge--icon">
    <i class="icon icon--s3 icon-001-account" aria-hidden="true"></i>
    <ng-container [ngTemplateOutlet]="badgeContent"></ng-container>
  </div>
</ng-template>

<ng-template #badgeContent>
  <span *ngIf="displayBadgeContent" class="badge__content">{{ contentNumber }}</span>
</ng-template>
